import { domainFormat } from "InitialData/regExp";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import InputEmail from "../signUp/InputEmail";


const EmailDomainSelector = forwardRef((props, ref) => {
    const inputTextRef = useRef();
    // 선택된 도메인을 저장하기 위한 상태
    const [selectedDomain, setSelectedDomain] = useState('');
    // 사용자가 '직접 입력'을 선택했을 때의 도메인을 저장하기 위한 상태
    const [customDomain, setCustomDomain] = useState('');

    // 도메인 선택이 변경되었을 때 호출되는 함수
    const handleDomainChange = (event) => {
        const value = event.target.value;
        setSelectedDomain(value);
        // '직접 입력'이 선택되면, customDomain을 초기화합니다.
        if (value !== 'custom') {
            setCustomDomain('');
        }
    };

    // 사용자가 '직접 입력'을 선택했을 때 호출되는 함수
    const handleCustomDomainChange = (event) => {
        setCustomDomain(event.target.value);
    };
    const isValidDomain = () => {
        if (selectedDomain === 'custom') {
            
            return domainFormat.exp.test(customDomain); // 도메인 형식 검사

        }
        return true; // '직접 입력'이 아니라면 항상 true
    };

    useImperativeHandle(ref, () => ({
        getSelectedDomain: () => selectedDomain === 'custom' ? customDomain : selectedDomain,
        isValid() {
            
            return isValidDomain();
        },
        focus() {
            if (selectedDomain === 'custom' && !isValidDomain()) {
                // '직접 입력'이 선택되었고 도메인 형식이 유효하지 않은 경우, InputEmail 컴포넌트로 포커스 이동
                inputTextRef.current.focus();
            }
        },

    }));

    return (
        <HorizontalFlex gap={15}>
            <FlexChild width={"max-content"}>
                <select value={selectedDomain} onChange={handleDomainChange} style={{ height: "37px" }}>
                    <option value="">도메인을 선택하세요</option>
                    <option value="naver.com">naver.com</option>
                    <option value="gmail.com">gmail.com</option>
                    <option value="daum.net">daum.net</option>
                    <option value="custom">직접 입력</option>
                </select>
            </FlexChild>
            <FlexChild>
                <InputEmail
                    regExp={[domainFormat]}
                    ref={inputTextRef}
                    onChange={(value) => setCustomDomain(value)}
                    placeHolder={selectedDomain !== 'custom' ? null : "직접 입력"}
                    value={customDomain}
                    disabled={selectedDomain !== 'custom'}
                />
            </FlexChild>
        </HorizontalFlex>
    );
})


export default EmailDomainSelector;